import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import LegalCmsContent from '@/components/shared/LegalCmsContent';
import { selectBtag } from '@/store/selectors/commonSelectors';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import { BffStaticTextContentResponse, CmsStaticTextContentType } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';
import { BaseModalProps, MODALS } from '@/features/modal/types';
import { useModal } from '@/features/modal/useModal';

const BonusTermsAndConditionsContent = () => {
  const btag = useSelector(selectBtag);
  const { request, data, loading } = useBffApiRequest<BffStaticTextContentResponse>();

  useEffect(() => {
    request({
      apiMethod: BffApiService.getStaticTextContent,
      axiosConfig: { params: { contentType: CmsStaticTextContentType.bonusTerms, btag } },
    });
  }, []);

  return <LegalCmsContent data={data} loading={loading} />;
};

export interface BonusTermsAndConditionsModalProps {
  customTermsAndConditionsDescription?: string;
}

export const BonusTermsAndConditionsModal = ({
  closeModal,
  customTermsAndConditionsDescription,
}: BonusTermsAndConditionsModalProps & Pick<BaseModalProps, 'closeModal'>): JSX.Element => {
  const intl = useIntl();
  const { openModal } = useModal();

  return (
    <div className="overflow-auto bonus-terms-modal prose relative flex w-full max-w-lg xl:max-w-2xl flex-col  rounded-lg bg-white px-4 pt-16 pb-4 text-left md:px-8">
      <CloseButton left onClick={closeModal} />
      {!customTermsAndConditionsDescription && <BonusTermsAndConditionsContent />}
      {customTermsAndConditionsDescription && (
        <LegalCmsContent
          data={{ title: '', content: customTermsAndConditionsDescription }}
          showTitle={false}
          loading={false}
        />
      )}
      <button
        type="button"
        onClick={() => openModal(MODALS.TERMS_AND_CONDITIONS)}
        className="mt-8 flex w-full items-center justify-center rounded-full bg-blue-light p-4 font-bold text-white shadow-md transition hover:bg-cyan-600 hover:shadow-lg"
      >
        {intl.formatMessage({
          id: 'bonusTerms.linkToTermsText',
        })}
      </button>
      <button
        type="button"
        className="p-4 font-bold text-black/60 transition-colors hover:text-black"
        onClick={() => {
          closeModal();
        }}
      >
        {intl.formatMessage({ id: 'termsAndConditions.closeButton' })}
      </button>
    </div>
  );
};
